/**
 * The Events container
 */
import React from "react";
import PropTypes from "prop-types";
import Page from "../components/Page/Page-component";
import { withRouter } from "react-router-dom";
import { Container } from "reactstrap";
import { env } from "@bkry/bowline-utils";
const { REACT_APP_CDN_PATH } = env;

/**
 * MintingSection container used as app default landing page
 */
const TermsOfServiceRaffle = (props, context) => {
  return (
    <Page
      id="TermsOfServiceRaffle"
      title={context.t("Terms & Conditions for a raffle")}
      style={{ paddingTop: "50px", fontSize: "2rem" }}
    >
      <Container>
        <div className="staticTextWrapper my-5">
          <h1>
            TEILNAHMEBEDINGUNGEN
            <br />
            für die COD3X Aktion der Samsung Electronics GmbH
          </h1>
          <p>
            Im Rahmen des COD3X Aktion veranstaltet die Samsung Electronics
            GmbH, Samsung House, Am Kronberger Hang 6, 65824 Schwalbach/Ts.,
            Deutschland (nachfolgend „<strong>Samsung</strong>“) die nachfolgend
            aufgeführten Gewinnspiele (jeweils ein &quot;
            <strong>Gewinnspiel</strong>
            &quot;) und Zugabeaktionen (&quot;<strong>Zugabeaktionen</strong>
            &quot;).
          </p>
          <h2>1. DEFINITIONEN</h2>
          <p>
            1.1 <strong>Aktionspartner</strong>meint (jeweils) Illuvium
            (www.illuvium.io), Ledger SAS (www.ledger.fr), World of Women (WOW
            Studio Ltd, www.worldofwomen.art), Wilder World (
            <a href="https://encoded-592c9deb-987b-4562-aa3c-9fa3d37d83e9.uri/http%3a%2f%2fwww.wilderworld.com)m">
              www.wilderworld.com)m
            </a>{" "}
            Belvedere Museum Wien, www.belvedere.at).
          </p>
          <p>
            1.2 <strong>GEN3RATOR</strong> meint die speziell für das
            WEB3-Universum von Samsung sowie ausgewählter Partner geschaffene
            und als &quot;GEN3RATOR&quot; bezeichneten NFT. Bei einem GEN3RATOR
            handelt es sich um einen rein digitalen (d.h. nicht physischen)
            Gegenstand. Ein GEN3RATOR ist aktiviert, wenn er mit einem GEN3 Chip
            verbunden wurde. Jeder GEN3RATOR ist entweder von Samsung (93 Stück
            inklusive Belveder Museum Gustaf Klimt NFT 75 Stück) oder einem
            Aktionspartner (Illuvium: 2.000 Stück; Ledger: 50 Stück; Wilder
            Worlds: 20 Stück; World of Women: 75 Stück) gebrandet.
          </p>
          <p>
            1.3 <strong>GEN3 Chip</strong> meint die speziell für das
            WEB3-Universum von Samsung sowie ausgewählter Partner geschaffene
            und als &quot;GEN3 Chip&quot; bezeichneten NFT. Bei dem GEN3CHIP NFT
            handelt es sich um einen rein digitalen (d.h. nicht physischen)
            Gegenstand. Mit den GEN3 Chips kann ein GEN3ERATOR aktiviert werden.
          </p>
          <p>
            1.4 <strong>Samsung NFT</strong> meint jeden NFT aus einer der
            folgenden Kollektionen: Samsung Europe Art Kollektion
            (https://opensea.io/SamsungEurope); oder Samsung TX1 by Paul
            Milinski
            (https://opensea.io/collection/samsung-tx1-by-paul-milinksi); oder
            Samsung MX1 GENESIS EDITION
            (https://opensea.io/collection/samsung-mx1-genesis-edition); oder
            Samsung
          </p>
          <p>
            <strong>Samsung WEB3 TV Bundle</strong> meint ein Bundle bestehend
            aus bestehend aus einem (1) TV Gerät 50&quot; The Frame LS03D QLED
            4K Art Mode Tizen OS™ Smart TV (2024) (
            <a href="https://www.samsung.com/de/lifestyle-tvs/the-frame/ls03d-50-inch-black-gq50ls03dauxzg/">
              https://www.samsung.com/de/lifestyle-tvs/the-frame/ls03d-50-inch-black-gq50ls03dauxzg/
            </a>{" "}
            Oder ein 43&quot; QLED 4K The Sero 4K LS05BG (2023){" "}
            <a href="https://www.samsung.com/de/lifestyle-tvs/the-sero/ls05bg-43-inch-the-sero-qled-4k-smarttv-navy-blue-gq43ls05bguxzg/">
              https://www.samsung.com/de/lifestyle-tvs/the-sero/ls05bg-43-inch-the-sero-qled-4k-smarttv-navy-blue-gq43ls05bguxzg/
            </a>{" "}
            einem (1) GEN3 Chip NFT sowie einem (1) Random GEN3RATOR NFT. Bei
            dem TV-Gerät handelt es sich um einen physischen, bei dem GEN3 Chip
            und dem GEN3RATOR um digitale Gewinne bzw. Zugaben.
          </p>
          <p>
            1.5 <strong>Teilnahmezeitraum</strong> meint den gesamten Zeitraum
            zwischen der Anmeldung eines Teilnehmers zu den Gewinnspielen
            entsprechend Ziffer 2.1) bis zum Zeitpunkt der Gewinnermittlung
            entsprechend Ziffer 2.4.
          </p>
          <p>
            1.6 <strong>Teilnahmeseite</strong> meint die Samsung Minting Pages
            unter https://gen3.samsung.com/de/community/membershiptiers oder
            https://gen3.samsung.com/de/community/benefits
          </p>
          <p>
            1.7 <strong>Tier 1 NFT</strong>
            https://gen3.samsung.com/de/community/membershiptiers/f41967bb-abad-45ec-90de-d64a5188b61c
          </p>
          <p>
            1.8 <strong>Tier 2 NFT</strong>
            https://gen3.samsung.com/de/community/membershiptiers/3c483858-3f7e-43a5-8c13-5157a6a15e95
          </p>
          <p>
            1.9 <strong>Tier 3 NFT</strong>
            https://gen3.samsung.com/de/community/membershiptiers/378afe1f-ebcc-407a-926a-09e1ab06ba84
          </p>
          <p>
            1.10 <strong>Tier 4 NFT</strong>
            https://gen3.samsung.com/de/community/membershiptiers/2bad9388-039e-4927-a936-d381c8a30bc1
          </p>
          <p>
            1.11 <strong>Tier 5 NFT</strong>
            https://gen3.samsung.com/de/community/membershiptiers/3c5c0534-128a-4ef4-8e4c-94baa7eddcab
          </p>
          <p>
            1.12 <strong>Tier 6 NFT</strong>
            https://gen3.samsung.com/de/community/membershiptiers/af40fcda-d17d-4af4-b502-90006bc322a9
          </p>
          <h2>2. GENERELLE TEILNAHMEBEDINGUNGEN</h2>
          <p>
            2.1. Teilnahmeberechtigt sind Personen, die im Teilnahmezeitraum
            mindestens 18 Jahren als sind, ihren Wohnsitz in Deutschland haben
            und ein Crypto-Wallet besitzen (oder sich erstellen).
          </p>
          <p>
            2.2 Eine Teilnahme ist nur während des Teilnahmezeitraums möglich.
          </p>
          <p>2.3 Jede Person darf an der COD3X Aktion nur einmal teilnehmen.</p>
          <p className="ps-3">
            2.3.1 Im Rahmen der COD3X Aktion darf jeder Teilnehmer an allen
            Gewinnspielen und Zugabeaktionen teilnehmen, zu denen er / sie nach
            diesen Teilnahmebedingungen teilnahmeberechtigt ist.
          </p>
          <p className="ps-3">
            2.3.2 Jeder Teilnehmer darf an jedem Raffle (s. Ziffer 4) sowie
            jedem Claim (s. Ziffer 5) nur einmal teilnehmen.
          </p>
          <p className="ps-3">
            2.3.3 An dem GEN3RATOR Raffle darf jeder mit jedem aktivierten
            GEN3RATOR, einmal teilnehmen. Hat ein Teilnehmer mehrere aktivierte
            GEN3RATOR, kann er / sie daher mehrmals teilnehmen.
          </p>
          <p>
            2.4 Mitarbeiter von Samsung, ihre Angehörige und andere an der
            Konzeption und Umsetzung beteiligte Personen sind von der Teilnahme
            ausgeschlossen.
          </p>
          <p>3. DURCHFÜHRUNG</p>
          <p>
            3.1 Um an den Gewinnspielen und den Zugabeaktionen teilzunehmen,
            muss sich der Teilnehmer ab 15.05.2024 bis 30.09.2024 mit seinem
            Crypto Wallet (in dem die jeweils erforderlichen NFT gehalten
            werden, s. Ziffer 4 bzw. Ziffer 5) auf einer Teilnahmeseite
            registrieren. Im Rahmen der Registrierung muss eine gültige
            E-Mail-Adresse mitgeteilt werden, unter der der Teilnehmer im Fall
            eines Gewinns kontaktiert werden kann.
          </p>
          <p>
            3.2 Jedes einzelne Gewinnspiel nach nach Ziffer 3.1 bedarf einer
            separaten Anmeldung mittels Blockchain Signatur. Die Teilnehmer
            müsssen sich für jedes Gewinnspiel / Raffle separat anmelden.
          </p>
          <p>
            3.3 Mit einer Registrierung nach Ziffer 3.1 akzeptiert der
            Teilnehmer gleichzeitig die hier aufgeführten Teilnahmebedingungen.
          </p>
          <p>
            3.4 Die Gewinner jedes Gewinnspiels werden unter sämtlichen an dem
            jeweiligen Gewinnspiel teilnahmeberechtigten Teilnehmern zwischen
            dem 01.06.2024 und dem 30.06.2024 per Zufall ermittelt. Die Gewinner
            werden per E-Mail von der Adresse{" "}
            <a href="mailto:support@nft-samsung.de">support@nft-samsung.de</a>{" "}
            über die von ihnen angegebene E-Mail-Adresse informiert. Bei einem
            physischen Gewinn werden sie darin zudem aufgefordert, ihre Adresse
            mitzuteilen.
          </p>
          <h2>
            4. TEILNAHMEVORAUSSETZUNGEN UND GEWINNE DER EINZELNEN GEWINNSPIELE
          </h2>
          <p>
            4.1 Im Rahmen des COD3X Gesamt-Gewinnspiels werden die folgenden
            Einzel-Gewinnspiele veranstaltet:
          </p>
          <p>
            <strong>4.2 Raffle 1 und Raffle 2:</strong>
          </p>
          <p className="ps-3">
            4.2.1 Teilnahmeberechtigt an Raffle 1 und Raffle 2 sind Teilnehmer
            nach Ziffer 2.1, die im gesamten Teilnahmezeitraum mindestens einen
            (1) Samsung-NFT in ihrem Crypto-Wallet halten.
          </p>
          <p className="ps-3">
            4.2.2 Unter allen Raffle 1 Teilnehmern werden 2.500 mal je ein (1)
            GEN3 CHIP NFT entsprechend Ziffer 3.4 verlost.
          </p>
          <p className="ps-3">
            4.2.3 Unter allen Raffle 2 Teilnehmern werden 50 mal je ein (1)
            GEN3RATOR entsprechend Ziffer 3.4 verlost, die nach dem
            Zufallsprinzip jeweils von Samsung oder einem Aktionspartner
            gebranded sind.
          </p>
          <p>
            <strong>4.3. Raffle 3:</strong>
          </p>
          <p className="ps-3">
            4.3.1 Teilnahmeberechtigt an Raffle 3 sind alle nach Ziffer 2.1
            teilnahmeberechtigten Teilnehmer, die zudem im gesamten
            Teilnahmezeitraum
          </p>
          <p className="ps-5">
            (a) mindestens einen (1) Samsung-NFT in ihrem Crypto-Wallet halten;
            sowie
          </p>
          <p className="ps-5">
            (b) eines der folgenden Sets in ihrem Crypto-Wallet halten:
          </p>
          <p className="ps-5 ms-5">
            (i) mindestens vier (4) Tier 1 NFTs (wobei je erhältlicher
            Farbvariante mindestens ein NFT gehalten werden muss), oder
          </p>
          <p className="ps-5 ms-5">
            (ii) mindestens vier (4) Tier 2 NFTs (wobei je erhältlicher
            Farbvariante mindestens ein NFT gehalten werden muss), oder
          </p>
          <p className="ps-5 ms-5">
            (iii) mindestens vier (4) Tier 3 NFTs (wobei je erhältlicher
            Farbvariante mindestens ein NFT gehalten werden muss), oder
          </p>
          <p className="ps-5 ms-5">
            (iv) mindestens vier (4) Tier 4 NFTs (wobei je erhältlicher
            Rarity-Klasse mindestens ein NFT (egal welcher Farbe) gehalten
            werden muss), oder
          </p>
          <p className="ps-5 ms-5">
            (v) mindestens vier (4) Tier 5 NFTs (wobei je erhältlicher
            Farbvariante mindestens ein 1 NFT gehalten werden muss), oder
          </p>

          <p className="ps-5 ms-5">
            (vi) mindestens acht (8) Tier 6 NFTs, zusammengesetzt wie folgt: ein
            NFT jeder MX1GE-Gruppe; ein NFT je Künstler; ein MX1AC-NFT und ein
            TX1-NFT. (siehe Abbildung)
          </p>
          <p className="ps-5 ms-5">
            MX1 GENSIS EDITION{" "}
            <a href="https://opensea.io/collection/samsung-mx1-genesis-edition">
              https://opensea.io/collection/samsung-mx1-genesis-edition
            </a>
          </p>
          <p className="ps-5 ms-5">
            MX1 ART Collection{" "}
            <a href="https://opensea.io/collection/samsung-mx1-art-collection">
              https://opensea.io/collection/samsung-mx1-art-collection
            </a>
          </p>
          <p className="ps-5 ms-5">
            TX1 GENESIS EDITION{" "}
            <a href="https://opensea.io/collection/samsung-tx1-by-paul-milinksi">
              https://opensea.io/collection/samsung-tx1-by-paul-milinksi
            </a>
          </p>
          <p className="ps-5 ms-5">(vii)</p>
          <p className="ps-5 ms-5">(viii)</p>
          <p className="ps-3">
            4.3.2 Unter allen Raffle 3 Teilnehmern werden 100 mal je ein (1)
            GEN3RATOR (ohne GEN3 Chip) entsprechend Ziffer 3.4 verlost, die nach
            dem Zufallsprinzip jeweils von Samsung oder einem Aktionspartner
            gebranded sind.
          </p>
          <p>
            <strong>4.4 Raffle 4:</strong>
          </p>
          <p className="ps-3">
            4.4.1 Teilnahmeberechtigt an Raffle 4 sind alle nach Ziffer 2.1
            teilnahmeberechtigten Teilnehmer, die zudem im gesamten
            Teilnahmezeitraum
          </p>
          <p className="ps-5">
            (a) mindestens einen (1) Samsung-NFT in ihrem Crypto-Wallet halten;
            sowie
          </p>
          <p className="ps-5">
            (b) eines der folgenden Sets in ihrem Crypto-Wallet halten:
          </p>

          <p className="ps-5 ms-5">
            (i) mindestens vier (4) Tier 2 NFTs (wobei je erhältlicher
            Farbvariante mindestens ein NFT gehalten werden muss), oder
          </p>
          <p className="ps-5 ms-5">
            (ii) mindestens vier (4) Tier 3 NFTs (wobei je erhältlicher
            Farbvariante mindestens ein NFT gehalten werden muss), oder
          </p>
          <p className="ps-5 ms-5">
            (iii) mindestens vier (4) Tier 4 NFTs (wobei je erhältlicher
            Rarity-Klasse mindestens ein NFT (egal welcher Farbe) gehalten
            werden muss), oder
          </p>
          <p className="ps-5 ms-5">
            (iv) mindestens vier (4) Tier 5 NFTs (wobei je erhältlicher
            Farbvariante mindestens ein 1 NFT gehalten werden muss), oder
          </p>
          <p className="ps-5 ms-5">
            (v) mindestens acht (8) Tier 6 NFTs, zusammengesetzt wie folgt: ein
            NFT jeder MX1GE-Gruppe; ein NFT je Künstler; ein MX1AC-NFT und ein
            TX1-NFT.
          </p>

          <p className="ps-3">
            4.4.2 Unter allen Raffle 4 Teilnehmern werden 150 mal je ein (1)
            GEN3RATOR inkl. GEN3 Chip entsprechend Ziffer 3.4 verlost, die nach
            dem Zufallsprinzip jeweils von Samsung oder einem Aktionspartner
            gebranded sind.
          </p>
          <p>
            <strong>4.5 Raffle 5:</strong>
          </p>
          <p className="ps-3">
            4.5.1 Teilnahmeberechtigt an Raffle 5 sind alle nach Ziffer 2.1
            teilnahmeberechtigten Teilnehmer, die zudem an einer der folgenden
            Aktionen teilnahmeberechtigt sind: Raffle 3, Raffle 4, Claim 1,
            Claim 2, Claim 3.
          </p>
          <p className="ps-3">
            4.5.2 Unter allen Raffle 5 Teilnehmern wird ein (1) Samsung WEB3 TV
            Bundle, entsprechend Ziffer 3.4 verlost.
          </p>
          <h2>5. ZUGABEAKTIONEN</h2>
          <p>
            5.1 Im Rahmen des COD3X Gesamt-Gewinnspiels werden neben den
            Einzel-Gewinnspielen die folgenden Zugabeaktionen veranstaltet:
          </p>
          <p>
            <strong>5.2 Claim 1</strong>
          </p>
          <p className="ps-3">
            5.2.1 Teilnahmeberechtigt an Claim 1 sind alle nach Ziffer 2.1
            teilnahmeberechtigten Teilnehmer, die zudem im gesamten
            Teilnahmezeitraum
          </p>
          <p className="ps-5">
            (a) mindestens einen (1) Samsung-NFT in ihrem Crypto-Wallet halten;
            sowie
          </p>
          <p className="ps-5">
            (b) eines der folgenden Sets in ihrem Crypto-Wallet halten:
          </p>
          <p className="ps-5 ms-5">
            (i) mindestens vier (4) Tier 3 NFTs (wobei je erhältlicher
            Farbvariante mindestens ein NFT gehalten werden muss), oder
          </p>
          <p className="ps-5 ms-5">
            (ii) mindestens vier (4) Tier 4 NFTs (wobei je erhältlicher
            Rarity-Klasse mindestens ein NFT (egal welcher Farbe) gehalten
            werden muss), oder
          </p>
          <p className="ps-5 ms-5">
            (iii) mindestens vier (4) Tier 5 NFTs (wobei je erhältlicher
            Farbvariante mindestens ein 1 NFT gehalten werden muss), oder
          </p>
          <p className="ps-5 ms-5">
            (iv) mindestens acht (8) Tier 6 NFTs, zusammengesetzt wie folgt: ein
            NFT jeder MX1GE-Gruppe; ein NFT je Künstler; ein MX1AC-NFT und ein
            TX1-NFT.
          </p>
          <p>
            <strong>5.3 Claim 2</strong>
          </p>
          <p className="ps-3">
            5.3.1 Teilnahmeberechtigt an Claim 2 sind alle nach Ziffer 2.1
            teilnahmeberechtigten Teilnehmer, die zudem im gesamten
            Teilnahmezeitraum
          </p>
          <p className="ps-5">
            (a) mindestens einen (1) Samsung-NFT in ihrem Crypto-Wallet halten;
            sowie
          </p>
          <p className="ps-5">
            (b) eines der folgenden Sets in ihrem Crypto-Wallet halten:
          </p>
          <p className="ps-5 ms-5">
            (i) mindestens vier (4) Tier 5 NFTs (wobei je erhältlicher
            Farbvariante mindestens ein 1 NFT gehalten werden muss), oder
          </p>
          <p className="ps-5 ms-5">
            (ii) mindestens acht (8) Tier 6 NFTs, zusammengesetzt wie folgt: ein
            NFT jeder MX1GE-Gruppe; ein NFT je Künstler; ein MX1AC-NFT und ein
            TX1-NFT.
          </p>
          <p className="ps-3">
            5.3.2 Die ersten 236 berechtigten Teilnehmer, die sich auf der
            Teilnahmewebseite anmelden, erhalten einen (1) GEN3RATOR (ohne GEN3
            Chip), der nach dem Zufallsprinzip jeweils von Samsung oder einem
            Aktionspartner gebranded ist.
          </p>
          <p>
            <strong>5.4 Claim 3</strong>
          </p>
          <p className="ps-3">
            5.4.1 Teilnahmeberechtigt an Claim 3 sind alle nach Ziffer 2.1
            teilnahmeberechtigten Teilnehmer, die zudem im gesamten
            Teilnahmezeitraum
          </p>
          <p className="ps-5 ms-5">
            (i) mindestens einen (1) Samsung-NFT in ihrem Crypto-Wallet halten;
            sowie
          </p>
          <p className="ps-5 ms-5">
            (ii) mindestens acht (8) Tier 6 NFTs in ihrem Crypto-Wallet halten,
            zusammengesetzt wie folgt: ein NFT jeder MX1GE-Gruppe; ein NFT je
            Künstler; ein MX1AC-NFT und ein TX1-NFT.
          </p>
          <p className="ps-3">
            5.4.2 82 berechtigte Teilnehmer, die sich auf der Teilnahmewebseite
            anmelden, erhalten einen (1) GEN3RATOR inkl. GEN3 Chip, der nach dem
            Zufallsprinzip jeweils von Samsung oder einem Aktionspartner
            gebranded ist.
          </p>
          <h2>6. GEN3RATOR RAFFLE</h2>
          <p>
            6.1 Teilnahmeberechtigt am GEN3RATOR Raffle sind alle nach Ziffer
            2.1 teilnahmeberechtigten Teilnehmer, die zum Zeitpunkt der
            Gewinnermittlung (Ziffer 3.4) mit mindestens einem (1) aktivierten
            GEN3RATOR auf der Teilnahmeseite angemeldet sind.
          </p>
          <p>
            6.2 Unter allen Teilnehmern, die mit einem
            <strong>Samsung-gebrandeten</strong> GEN3ERATOR angemeldet sind,
            werden folgenden Gewinne verlost:
          </p>
          <p className="ps-3">
            6.2.1 3 mal je ein (1){" "}
            <span className="text-decoration-underline">
              Samsung WEB3 TV Bundle
            </span>
            ;
          </p>
          <p className="ps-3">
            6.2.2 5 mal je ein (1){" "}
            <span className="text-decoration-underline">
              Samsung Galaxy S23 Ultra
            </span>
            , (physischer Gewinn);
          </p>
          <p className="ps-3">
            6.2.3 5 mal je ein (1){" "}
            <span className="text-decoration-underline">
              Samsung Galaxy S24 Ultra
            </span>
            , (physischer Gewinn);
          </p>
          <p className="ps-3">
            6.2.4 5 mal je ein (1){" "}
            <span className="text-decoration-underline">
              Samsung MX1 Ledger Nano X special packaging
            </span>
            ,
          </p>
          <p className="ps-3">
            6.2.5 50 x je ein (1){" "}
            <span className="text-decoration-underline">
              Samsung TX1 Custom Ledger Nano X
            </span>
            ,] (physischer Gewinn).
          </p>
          <p>
            6.3 Unter allen Teilnehmern, die mit einem
            <strong>Illuvium-gebrandeten</strong> GEN3ERATOR angemeldet sind,
            werden folgenden Gewinne verlost: Illuvium Ranger Skin Set
          </p>
          <p>
            6.4 Unter allen Teilnehmern, die mit einem
            <strong>Wilder World-gebrandeten</strong> GEN3ERATOR angemeldet
            sind, werden folgenden Gewinne verlost: Widler Moto NFTs, Wilder
            Beasts NFTs, Wilder Wapes NFTs, Wilder Wheels NFTS
          </p>
          <p>
            6.5 Unter allen Teilnehmern, die mit einem
            <strong>World of Women-gebrandeten</strong> GEN3ERATOR angemeldet
            sind, werden folgenden Gewinne verlost: World of Women NFT, World of
            Women Galaxy NFTs, Art Fest NFTs
          </p>
          <p>
            6.6 Unter allen Teilnehmern, die mit einem
            <strong>Ledger-gebrandeten</strong> GEN3ERATOR angemeldet sind,
            werden folgenden Gewinne verlost: Custom Legder Nano X
          </p>
          <p>
            6.7 Unter allen Teilnehmern, die mit einem
            <strong>Samsung-gebrandeten</strong> GEN3ERATOR angemeldet sind,
            werden folgenden Gewinne verlost: Gustav Klimt NFT
          </p>
          <h2>7. ÜBERMITTLUNG DER GEWINNE BZW. ZUGABEN</h2>
          <p>7.1 Digitale Gewinne und Zugaben:</p>
          <p className="ps-3">
            7.1.1 Digitale Gewinne erhalten die Gewinner innerhalb von drei (5)
            Arbeitstagen nach Ermittlung der Gewinner als Voucher Code per
            E-Mail an die bei Registrierung angegebene E-Mail-Adresse übersandt.
          </p>
          <p className="ps-3">
            7.1.2 Digitale Zugaben erhalten die berechtigten Teilnehmer
            innerhalb von drei (5) Arbeitstagen nach erfolgter Registrierung als
            Voucher Code per E-Mail an die bei Registrierung angegebene
            E-Mail-Adresse übersandt.
          </p>
          <p className="ps-3">
            7.1.3 Voucher-Codes für digitale Zugaben und/oder Gewinne können
            innerhalb von [4 Wochen] nach Übersendung auf{" "}
            <a href="https://gen3.samsung.com/de">
              https://gen3.samsung.com/de
            </a>{" "}
            eingelöst werden.
          </p>
          <p className="ps-3">
            7.1.4 Die den Gewinnern bzw. Teilnehmern an den einzelnen digitalen
            Gewinnen und/oder Zugaben eingeräumten Rechte und
            Nutzungsmöglichkeiten richten sich nach den Bedingungen der
            jeweiligen Aktionspartners und können unterschiedlich ausgestaltet
            sein. Teilnehmer bzw. Gewinner sind selbst dafür verantwortlich,
            sich über diese Bedingungen zu informieren und diese Bedingungen
            einzuhalten. Die Bedingungen für von Samsung verantwortet digitale
            Gewinne bzw. Zugaben können{" "}
            <a href="https://gen3.samsung.com/de/community/collabs">
              https://gen3.samsung.com/de/community/collabs
            </a>
          </p>
          <p className="ps-3">
            eingesehen werden. Die Bedingungen für von Aktionspartner
            verantwortete digitale Gewinne bzw. Zugaben können auf den in Ziffer
            1.1 genannten Webseiten eingesehen werden.
          </p>
          <p>
            7.2 Physische Gewinne werden den jeweiligen Gewinnern innerhalb von
            vier (4) Wochen nach Mitteilung ihrer Adresse an diese übersandt.
          </p>
          <p>
            7.3 Die Gewinne bzw. Zugaben sind nicht verhandelbar oder
            umtauschbar. Die Erteilung von Gutschriften oder eine Auszahlung in
            bar ist ausgeschlossen. Samsung behält sich (auch für seine
            Aktionspartner) das Recht vor, einen Gewinn und/oder eine Zugabe
            durch einen anderen Gewinn / eine andere Zugabe in einem ähnlichen
            Wert zu ersetzen, sofern der eigentliche Gewinn / die eigentliche
            Zugabe aus Gründen, die außerhalb des Verantwortungsbereichs von
            Samsung (bzw. des betroffenen Aktionspartner) liegen, nicht mehr
            erhältlich ist.
          </p>
          <h2>8.AUSSCHLUSS VON DER AKTION</h2>
          <p>
            8.1 Samsung ist berechtigt, Teilnehmer von dieser Aktion
            auszuschließen, die gegen diese Teilnahmebedingungen verstoßen,
            falsche, irreführende oder betrügerische Angaben machen, sich
            unlauterer Hilfsmittel bedienen und/oder versuchen, an der Aktion
            (einschließlich einzelner Gewinnspiele oder Zugabeaktionen) mehrfach
            teilzunehmen oder das Verlosungsergebnis zu manipulieren. Samsung
            behält sich das Recht vor, Nachweise zur Überprüfung der
            Teilnahmevoraussetzungen (z.B. Altersbestimmung, Nachweis des
            Wohnsitzes in Deutschland, Inhaberschaft der NFTs während des
            Teilnahmezeitraums etc.) einzufordern.
          </p>
          <p>
            8.2 Liegt ein Ausschlussgrund vor, ist Samsung – auch nachträglich –
            berechtigt, Gewinne abzuerkennen und bereits ausgehändigte Gewinne
            bzw. Zugaben zurückzufordern bzw. Wertersatz zu verlangen sowie
            einen Ersatzgewinner gemäß Ziffer 3.4 zu ermitteln.
          </p>
          <h2>9. HAFTUNG</h2>
          <p>
            9.1 Samsung übernimmt keine Haftung dafür, dass Webseiten oder Links
            verfügbar und von den Teilnehmern technisch fehlerfrei und
            vollständig abrufbar sind. Insbesondere wird keine Haftung für
            Schäden und Verluste oder Löschungen von Daten, die sich aus
            technischen Störungen oder Verzögerungen, Viren oder ähnlichen
            Gründen ergeben, übernommen.
          </p>
          <p>
            9.2 Samsung oder die Aktionspartner haften nicht für Schäden, die
            bei der Durchführung der Aktion oder der Inanspruchnahme oder
            Nutzung eines Gewinns oder einer Zugabe entstehen. Nicht
            ausgeschlossen ist jedoch die gesetzliche Haftung für (a)
            Personenschäden oder Todesfälle, (b) vorsätzlich oder grob
            fahrlässig verursachte Schäden, (c) Schäden aufgrund von
            Verletzungen einer wesentlichen Vertragspflicht, d.h. einer Pflicht,
            auf deren Erfüllung sich der Teilnehmer verlassen durfte und
            verlassen hat, sowie (d) Fälle, in denen eine Haftung aufgrund von
            Gesetz nicht ausgeschlossen werden kann, wie bspw. aufgrund des
            Produkthaftungsgesetzes. Soweit Samsung bzw. ein Aktionspartner eine
            wesentliche Vertragspflicht leicht fahrlässig verletzt, ist die
            Haftung auf den typischerweise vorhersehbaren Schaden begrenzt.
          </p>
          <h2>10. SONSTIGES</h2>
          <p>
            10.1 Samsung ist berechtigt, die Aktion vorzeitig zu beenden. Dies
            gilt insbesondere für Fälle höherer Gewalt und für den Fall, dass
            eine ordnungsgemäße Durchführung der Aktion aus technischen und/oder
            rechtlichen Gründen nicht gewährleistet werden kann.
          </p>
          <p>
            10.2 Sollte eine Bestimmung dieser Teilnahmebedingungen ganz oder
            teilweise unwirksam sein oder werden, so berührt dies nicht die
            Gültigkeit der übrigen Bestimmungen. Eine unwirksame Bestimmung ist
            durch eine solche zu ersetzen, die rechtlich möglich ist und der
            unwirksamen inhaltlich am nächsten kommt. Entsprechendes gilt für
            eventuelle Regelungslücken.
          </p>
          <p>10.3 Es gilt das Recht der Bundesrepublik Deutschland.</p>
          <h2>11. ÜBERSICHTSTABELLE</h2>
          <img
            src={
              (REACT_APP_CDN_PATH || "") +
              "/images/Samsung_Generator_Overview.png"
            }
            alt="Samsung Generator Overview"
            width="100%"
            height="auto"
          />
        </div>
      </Container>
    </Page>
  );
};

/**  define proptype for the 'translation' function  */
TermsOfServiceRaffle.contextTypes = {
  t: PropTypes.func,
};

/** export the component as redux connected component */
export default withRouter(TermsOfServiceRaffle);
